import { collectionEngine, collectionEngineV1 } from '../apis.js';
const req = collectionEngine('/home');
const reqV1 = collectionEngineV1('/updates');
export const get = (caseFilter, force = false) => req('POST', '', {
    force: force,
    body: {
        caseFilter,
    },
});
export const getPausedCases = (caseFilter, creditorId) => reqV1('POST', `/grouped${creditorId ? `?creditorId=${creditorId}` : ''}`, {
    body: {
        caseFilter,
    },
});
//# sourceMappingURL=home.js.map